import Navbar from '../home/Navbar';
import Sidebar from '../sidebar/Sidebar';
import {AnimatePresence} from 'framer-motion';
import React, {useState} from 'react';
import {Outlet} from 'react-router-dom';

const HomeLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className='flex sm:h-screen h-full w-full'>
      <div className={`${isSidebarOpen ? 'block' : 'hidden'} sm:block`}>
        <AnimatePresence>
          <Sidebar
            isOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            key={'sidebar'}
          />
        </AnimatePresence>
      </div>
      <div className='flex-1 flex flex-col w-full h-full overflow-auto bg-gray-100'>
        <Navbar toggleSidebar={toggleSidebar} />
        <Outlet />
      </div>
    </div>
  );
};

export default HomeLayout;
